import { useUpdateSnapshot } from 'features/snapshots/api/updateSnapshot';
import { queryClient } from 'lib/react-query';
import { Snapshot } from 'types';
import { HistorySettingsForm } from '../types';

export const useSnapshotLockers = (snapshots: Snapshot[]) => {
  const updateSnapshot = useUpdateSnapshot({
    config: {
      onSuccess: (data: Snapshot) => {
        queryClient.invalidateQueries(['snapshot', data.id]);
        queryClient.refetchQueries(['snapshots', data.analyzer_id]);
        queryClient.invalidateQueries(['allSnapshotHistorySettings']);
      },
    },
  });
  const updateLock = async (form: HistorySettingsForm) => {
    if (form.snapshot_id)
      await updateSnapshot.mutateAsync({
        snapshotId: form.snapshot_id,
        data: { recording_locked: form.recording_locked },
      });
  };
  const updateAllLocks = async (form: HistorySettingsForm) => {
    for await (const snapshotItem of snapshots) {
      await updateSnapshot.mutateAsync({
        snapshotId: snapshotItem.id,
        data: { recording_locked: form.recording_locked },
      });
    }
  };
  return { updateLock, updateAllLocks };
};
